import React from "react";
import { Mic } from "lucide-react";
import { useVoiceInput } from "./useVoiceInput";

const VoiceInput = ({ name, value, onChange, placeholder, required }) => {
  const { startListening, isListening } = useVoiceInput((text) => {
    onChange({ target: { name, value: text } });
  });

  return (
    <div className="relative w-full">
      <input
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="w-full border rounded px-3 py-3 text-sm pr-20 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      {/* Listening indicator text */}
      {/* {isListening && (
        <span className="absolute left-3 top-1 text-xs text-red-600 animate-pulse">
          Listening...
        </span>
      )} */}

      {/* Mic Button */}
      <button
        type="button"
        onClick={startListening}
        className={`absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-full transition duration-200
          ${isListening ? "bg-red-300 animate-pulse" : "bg-blue-100"}
        `}
      >
        <Mic
          size={18}
          className={isListening ? "text-red-600" : "text-blue-600"}
        />
      </button>
    </div>
  );
};

export default VoiceInput;
